import axios from "axios.js";
import { showSnackbar } from "./UiAction";

export const GET_VEHICLE_LIST = "GET_VEHICLE_LIST";
export const GET_DRIVER = "GET_DRIVER";
export const CREATE_VEHICLE = "CREATE_VEHICLE";
export const DELETE_VEHICLE = "DELETE_VEHICLE";
export const UPDATE_VEHICLE = "UPDATE_VEHICLE";
export const STUDENT_ASSIGN_VEHICLE = "STUDENT_ASSIGN_VEHICLE";
export const VEHICLE_STUDENTS_LIST = "VEHICLE_STUDENTS_LIST";
export const STUDENTS_LIST_DATA = "STUDENTS_LIST_DATA";
export const VEHICLE_DEACTIVE = "VEHICLE_DEACTIVE"
export const VEHICLE_ACTIVE = "VEHICLE_ACTIVE"

export const getVehicleList = (page, rowsPerPage, data) => (dispatch) => { // get vehicle list api
  axios.post(`/vehicles?page=${page}&size=${rowsPerPage}`, data).then((res) => {
    dispatch({
      type: GET_VEHICLE_LIST,
      payload: res.data,
    });
  });
};

export const getDriverBySchool = (schoolId) => (dispatch) => { // get driver list by school api 
  axios.get(`schools/drivers/unassigned`).then((res) => {
    dispatch({
      type: GET_DRIVER,
      payload: res.data,
    });
  });
};

export const createVehicle = (data) => (dispatch) => { // reate vehicle api call
  axios
    .post("/vehicle/create", data)
    .then((response) => {
      dispatch(showSnackbar(response.data.message, 'top', "success"));
      dispatch({
        type: CREATE_VEHICLE,
        payload: response.data,
      });
      setTimeout(() => dispatch(getVehicleList(1, 100)), 1500);
    })
    .catch((error) => {
      dispatch(showSnackbar(error.message, 'top', "error"));
    });
};

export const deleteVehicle = (id) => (dispatch) => { // delete vehicle api
  axios.delete(`/vehicles/${id}/delete`).then((res) => {
    dispatch({
      type: DELETE_VEHICLE,
      payload: res.data,
    });
    dispatch(getVehicleList(1, 100));
    dispatch(showSnackbar(res.data.message, 'top', 'success'));
  })
  .catch((error) => {
    dispatch(showSnackbar(error.message, 'top', "error"));
  });
};

export const updateVehicle = (id, data) => (dispatch) => { // update vehicle api
  axios
    .post(`/vehicle/${id}/update`, data)
    .then((response) => {
      dispatch(showSnackbar(response.data.message, 'top', "success"));
      dispatch({
        type: UPDATE_VEHICLE,
        payload: response.data,
      });
      setTimeout(() => dispatch(getVehicleList(1, 100)), 1500);
    })
    .catch((error) => {
      dispatch(showSnackbar(error.message, 'top', "error"));
    });
};

export const studentAssignVehicle = (id, data) => (dispatch) => { // assign student to vehicle api
  axios
    .post(`/vehicle/${id}/update/students`, data, {
      headers: {
        "content-type": "application/json",
      },
    })
    .then((response) => {
      dispatch({
        type: STUDENT_ASSIGN_VEHICLE,
        payload: response.data,
      })
      dispatch(showSnackbar(response.data.message, 'top', "success"));
    })
    .catch((error) => {
      dispatch(showSnackbar(error.message, 'top', "error"));
    });
};

export const getVehicleStudentsListData = (data) => (dispatch) => { // get already assigned students list
  axios
    .post(`/vehicle/unassigned/students`, data, {
      headers: {
        "content-type": "application/json",
      },
    })
    .then((response) => {
      dispatch({
        type: VEHICLE_STUDENTS_LIST,
        payload: response.data,
      });
    })
};

export const getStudentsListData = (id) => (dispatch) => { // get student list school wise
  axios
    // .post(`https://students.ssavts.in/test.php?schoolId=${id}&std=&SecretKey=SSACTS17`)
    .get(`vehicle/manage/students/get`,{
      headers: {
        'filter_code': id,
      },
    })
    .then((response) => {
      dispatch({
        type: STUDENTS_LIST_DATA,
        payload: response.data,
      });
    })
};

export const vehicleDeactive = (id) => (dispatch) => { // deactive vehicle api
  axios.patch(`/vehicles/${id}/deactivate`).then((res) => {
    dispatch({
      type: VEHICLE_DEACTIVE,
      payload: res.data,
    });
    dispatch(getVehicleList(1,10));
    dispatch(showSnackbar(res.data.message, 'top', "success"));
  });
};

export const vehicleActive = (id) => (dispatch) => { // vehicle active api
  axios.patch(`/vehicles/${id}/activate`).then((res) => {
    dispatch({
      type: VEHICLE_ACTIVE,
      payload: res.data,
    });
    dispatch(getVehicleList(1,10));
    dispatch(showSnackbar(res.data.message, 'top', "success"));
  });
};